<template>
  <div class="animated fadeIn">
    <iframe :src="UrlOpenTShield" width="100%" style="height: 100vh; border: solid 1px #ccc; border-radius: 7px;" border="0"></iframe>
  </div>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import TShieldRepository from '@/shared/http/repositories/register/tshield.js'

export default {
  name: 'TShield',
  data () {
    return {
      user: null,
      data: {
        'login': process.env.TShieldAccess,
        'password': process.env.TShieldKey,
        'client': process.env.TShieldClient
      }
    }
  },
  computed: {
    UrlOpenTShield: function () {
      let urlFrame = null
      if (this.user && this.user.tokenGuid) {
        urlFrame = 'https://portal.tshield.com.br/login/' + this.user.tokenGuid
      }
      return urlFrame
    }
  },
  created () {
    this.onStartSSO()
  },
  methods: {
    onLoad () {},
    onStartSSO () {
      // loading.push()
      TShieldRepository.SignInSSO(this.data)
        .then((response) => {
          if (response.status === 200 && response.data.authenticated) {
            this.user = response.data.user
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
          toast.danger('Não foi possível iniciar o cadastro! <br>Tente novamente mais tarde.')
        })
    }
  }
}
</script>
<style scoped>
.bg-primary {
  background-color: #04a791!important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/tshield/tshield.vue